import { AppComponent } from "~core/AppComponent.js";
import {
  createCheckboxs,
  createSelects,
  createInputs,
} from "./form.templates.js";
export class Form extends AppComponent {
  constructor($root, options) {
    super($root, {
      name: "Form",
      listeners: ["change"],
      ...options,
    });

    this.setting = {};

    this.formFildcheck = [
      { name: "tooltipMove", checked: false},
      { name: "cross", checked: false},
      { name: "arrow", checked: false}
    ];
  }
  static className = ["app__form", "article"];
  toHTML() {
    const checkboxRender = () => createCheckboxs(this.formFildcheck);
    const selectRender = () =>
      createSelects([
        {name: 'position', options:["left", "right", "top", "bottom"]},
        {name: 'arrowPosition', options:["center", "bottom", "top", "left", "right"]},
      ]);
    const inputRender = () =>
      createInputs([
        { name: "margin", value: 15, type: "number" }
      ]);

    return (
      "<h3>Example</h3>" + selectRender() + inputRender() + checkboxRender()
    );
  }

  onChange(event) {
    let { name, checked, value } = event.target;
    const formFildInput = ["position", "arrowPosition"];

    const emit = (name, value) =>
      this.emitter.emit("form:change", this.setting, name, value);

    if (['tooltipMove', 'cross','arrow'].includes(name)) {
      this.setting[name] = checked;
      emit(name, checked);
      return;
    }

    if (formFildInput.includes(name)) {
      this.setting[name] = value.trim();
      emit(name, "'" + value + "'");
      return;
    }

    if (name) {
      value = Number.parseInt(value);
      if (value <= 1) {
        event.target.value = 1;
        value = 1;
      }
      this.setting[name] = value;
      emit(name, value);
      return;
    }
  }
}
